import { tuuleliinidTranslations } from '@/lang/tuuleliinid'
import { tuuleliinidMessages } from '@/lang/tuuleliinid/messages'
import { kihnuTranslations } from '@/lang/kihnu'
import { kihnuMessages } from '@/lang/kihnu/messages'
import { sarkTranslations } from '@/lang/sark'
import { sarkMessages } from '@/lang/sark/messages'
import { trialTranslations } from '@/lang/trial'
import { trialMessages } from '@/lang/trial/messages'

const translations = {
  tuuleliinid: tuuleliinidTranslations,
  kihnu: kihnuTranslations,
  sark: sarkTranslations,
  trial: trialTranslations,
}

const messages = {
  tuuleliinid: tuuleliinidMessages,
  kihnu: kihnuMessages,
  sark: sarkMessages,
  trial: trialMessages,
}

export type AvailableTheme = keyof typeof translations

export const currentTranslations = translations[process.env.NEXT_PUBLIC_THEME as AvailableTheme] || {}
export const getCurrentTranslations = (theme: AvailableTheme) => translations[theme] || {}
// export const currentMessages: Messages = messages[process.env.NEXT_PUBLIC_THEME as AvailableTheme] || {}
export const getMessages = (theme: AvailableTheme) => messages[theme]
